export type SalesInvoiceStatus =
  | 'DRAFT' | 'ISSUED' | 'PARTIALLY_PAID' | 'PAID' | 'VOIDED';

type ChipColor = 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';

export const SALES_INVOICE_STATUS_COLORS: Record<SalesInvoiceStatus, ChipColor> = {
  DRAFT: 'default',
  ISSUED: 'warning',
  PARTIALLY_PAID: 'info',
  PAID: 'success',
  VOIDED: 'error',
};

// Mirrors SalesInvoiceLineDTO (IdHolder gives id)
export interface SalesInvoiceLine {
  id: string;
  salesInvoiceId: string;
  description: string;
  quantity: number;
  unitPrice: number;
  taxRatePct: number;
  lineTax?: number;
  lineTotal?: number;
  revenueAccountId?: string;
  segmentId?: string;
}

// Mirrors SalesInvoiceDTO (IdHolder gives id)
export interface SalesInvoice {
  id: string;
  invoiceNumber?: string;
  customerId: string;
  customerName?: string;
  quotationId?: string;
  issueDate: string;
  dueDate: string;
  status: SalesInvoiceStatus;
  subtotal: number;
  taxAmount: number;
  totalAmount: number;
  paidAmount: number;
  notes?: string;
  institutionId: string;
  journalEntryId?: string;
  reversalJournalEntryId?: string;
  voidReason?: string;
  overdue: boolean;
  lines: SalesInvoiceLine[];
}

// Mirrors SalesInvoiceLineCreateDTO
export interface SalesInvoiceLineCreateDTO {
  description: string;
  quantity: number;
  unitPrice: number;
  taxRatePct: number;
  revenueAccountId?: string;
  segmentId?: string;
}

// Mirrors SalesInvoiceCreateDTO
export interface SalesInvoiceCreateDTO {
  customerId: string;
  quotationId?: string;
  issueDate: string;
  dueDate: string;
  notes?: string;
  institutionId: string;
  lines: SalesInvoiceLineCreateDTO[];
}

// Mirrors SalesInvoiceLineEditDTO
// Backend uses lineId (not id) in SalesInvoiceLineEditDTO
export interface SalesInvoiceLineEditDTO {
  lineId: string;
  unitPrice: number;
  taxRatePct: number;
  description: string;
}

// Mirrors SalesInvoiceEditDTO + SalesInvoiceLineEditDTO
export interface SalesInvoiceEditDTO {
  editReason: string;
  issueDate: string;
  dueDate: string;
  notes?: string;
  lines: SalesInvoiceLineEditDTO[];
}

// Mirrors VoidRequestDTO
export interface VoidDTO {
  voidReason: string;
}

export interface SalesInvoicePage {
  content: SalesInvoice[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}
